if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButton?.addEventListener('click', this.onSubmitHandler.bind(this));
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
 
        this.handleErrorMessage();
 
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        this.submitButtonText.classList.add('hidden');
        const hideAddToAccount = window.dsc?.hideAddToAccount;

        try {    
          
          // This handles the "add to next box" logic which is separate
          const hasAddToNextBoxHiddenInput = this.form.querySelector('input[name="add_to_next_box"]');
          if (hasAddToNextBoxHiddenInput && !hideAddToAccount) {
            if (window.dsc?.ensureSubscriberHydrated) {
              await window.dsc.ensureSubscriberHydrated();
            }
            const ogUpcomingOrders = await window.dsc.ogGetOgUpcomingOrders(window?.dsc?.customerId);
            window.dsc.ogSortOGOrders(ogUpcomingOrders.results);
            const nextOrder = ogUpcomingOrders.results[0];
            const orderId = nextOrder.public_id;
            const productId = this.form.querySelector('input[name="id"]').value;
            const productQuantity = document.querySelector('input[name="quantity"]').value;
            const subscriptionFrequency = document.querySelector('#selling-plan-id');
 
            if (subscriptionFrequency) {
              const response = await window.dsc.ogAddItemToNextBox({ order: orderId, product: productId, quantity: productQuantity });
              const subscriptionFrequencyValue = window.dsc.ogFrequencyMap[subscriptionFrequency.value];
              await window.dsc.ogCreateFromItem({ item: response.public_id, every: subscriptionFrequencyValue });
              window.dsc.toggleInNextBoxMessageTextPDP(ogUpcomingOrders.results[0], true, true);
              window.dsc.toastMessage = window.dsc.addedToSubscription;
            } else {
              await window.dsc.ogAddItemToNextBox({ order: orderId, product: productId, quantity: productQuantity });
              window.dsc.toggleInNextBoxMessageTextPDP(ogUpcomingOrders.results[0], true, false);
              window.dsc.toastMessage = window.translations.customer.global.added_to_next_box;
            }
            if (window.dsc.toastMessage && window.dsc.toastMessage !== '') {
              window.dispatchEvent(new CustomEvent('toast', { detail: { type: 'success', message: window.dsc.toastMessage, product: window.dsc.product || null } }));
              window.dsc.toastMessage = '';
            }
            return; // Exit after handling "add to next box"
          }
 
          // Standard "add to cart" logic
          const variantId = this.variantIdInput.value;
          const discountEstimate = document.querySelector(`.discount-estimate[data-variant-id="${variantId}"]`);
          
          let items = [];
          let discountString = '';

          const payload = window.discountUtils.getCartPayload(variantId, discountEstimate);
          items = payload.items;
          discountString = payload.discountString;
          
          const body = {
            items,
            sections: this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [],
            sections_url: window.location.pathname
          };

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          }).then((response) => response.json());

          if (response.status) {
            this.handleErrorMessage(response.description || response.message, response.errors);
            return;
          }
 
          let finalCartState = response;
          if (discountString) {
            const discountResult = await window.discountUtils.applyDiscountToCart(discountString, this.cart, discountEstimate);
            if (discountResult) {
              finalCartState = discountResult;
            }
          }
          this.updateCartContents(finalCartState);
 
        } catch (error) {
          this.handleErrorMessage(error.message || window.cartStrings.error);
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          this.submitButtonText.classList.remove('hidden');
          if (window.dsc.toastMessage && window.dsc.toastMessage !== '') {
            window.dispatchEvent(new CustomEvent('toast', { detail: { type: 'success', message: window.dsc.toastMessage, product: window.dsc.product || null } }));
            window.dsc.toastMessage = '';
          }
        }
      }

      handleErrorMessage(errorMessage, errors = null) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }

        publish(PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: this.dataset.variantId,
          errors: errors,
          message: errorMessage,
        });

        // Handle sold out state
        if (errors && errors.quantity) {
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      updateCartContents(response) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: response.id,
          cartData: response,
        }); 

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cart.renderContents(response);
              });
            },
            { once: true },
          );
          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(response);
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

    }
  );
}